<template>
  <z-form class="z-card">
    <h4>{{ $t('pbx.sip-account.form.title.edit.in_phone') }}</h4>

    <div class="z-card__body">
      <z-form-group>
        <div class="row align-items-center">
          <label class="col-3 text-right">
            {{ $t('pbx.sip-account.form.field.in_phone') }}
          </label>

          <div class="col-9">
            <z-form-input>
              <i-select v-model="form.internal_number_id" :filterable="true" :clearable="true">
                <i-option
                  v-for="item in numbers"
                  :key="item.id"
                  :value="item.id"
                  :label="item.number"
                />
              </i-select>
            </z-form-input>
          </div>
        </div>
      </z-form-group>
    </div>
  </z-form>
</template>

<script>
  import isEqual from 'lodash-es/isEqual';

  export default {
    props: {
      numbers: {},
      value: {
        type: Object,
        default: () => {}
      }
    },

    data() {
      return {
        form: {}
      };
    },

    watch: {
      value: {
        handler: function(value) {
          const { internal_number_id = null } = value || {};
          this.form = { internal_number_id };
        },
        immediate: true,
        deep: true
      },

      form: {
        handler: function(form) {
          if (!isEqual(form, this.value)) {
            this.$emit('input', form);
          }
        },
        immediate: true,
        deep: true
      }
    }
  };
</script>
